'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _reactRedux = require("react-redux");

var _translate = _interopRequireDefault(require("./../translate"));

var _hofsearchMap = _interopRequireDefault(require("../hofsearch-map"));

var _hofsearchFilter = _interopRequireDefault(require("../hofsearch-filter"));

var _locationShareButton = _interopRequireDefault(require("../location-share-button"));

var _inputSuggest = _interopRequireDefault(require("./lib/input-suggest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SearchField = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchField, _React$Component);

  function SearchField(props) {
    var _this;

    _classCallCheck(this, SearchField);

    _this = _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).call(this, props));
    _this.state = {
      modalOpen: false,
      searchLength: 0,
      showSuggestions: false
    };
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.startSearchByLocation = _this.startSearchByLocation.bind(_assertThisInitialized(_this));
    _this.shareLocationError = _this.shareLocationError.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onReset = _this.onReset.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.handleClickInside = _this.handleClickInside.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.resetSuggestions = _this.resetSuggestions.bind(_assertThisInitialized(_this));
    _this.inputRef = _react.default.createRef();
    _this.suggestionsRef = _react.default.createRef();
    return _this;
  }

  _createClass(SearchField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Do not add the event listener immediately.
      // Wait for the animation, that is triggered on page switch, to prevent scrolling issues.
      // handles interaction with auto suggest
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "handleClickInside",
    value: function handleClickInside() {
      this.setState({
        showSuggestions: true
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.suggestionsRef.current && !this.suggestionsRef.current.contains(event.target)) {
        this.setState({
          showSuggestions: false
        });
      }
    }
  }, {
    key: "shareLocationError",
    value: function shareLocationError(error) {
      this.props.checkLocationShareError(error);
    }
  }, {
    key: "startSearchByLocation",
    value: function startSearchByLocation(position) {
      var sendQueryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (position.coords) {
        var lon = position.coords.longitude.toString();
        var lat = position.coords.latitude.toString();
        this.props.onPlaceSearch(lon, lat, sendQueryString);
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault();
      this.setState({
        showSuggestions: false
      });
      return this.props.onSearch(this.inputRef.current.value);
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      e.preventDefault();
      this.setState({
        searchLength: e.target.value.length
      });
      return this.props.handleInputChange(this.inputRef.current.value);
    }
  }, {
    key: "onReset",
    value: function onReset(e) {
      e.preventDefault();
      this.setState({
        searchLength: e.target.value.length
      });
      this.props.onSearch();
      return this.props.handleInputChange('');
    }
  }, {
    key: "resetSuggestions",
    value: function resetSuggestions(itemName) {
      this.setState({
        showSuggestions: false
      });
      this.props.onSearch(itemName, true);
    }
  }, {
    key: "render",
    value: function render() {
      var backgroundColorClass = '';
      var t = this.props.t;
      var count = this.props.getFilterCount();

      if (!this.props.viewportOffsetVisible) {
        backgroundColorClass = 'show-background-color';
      }

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'search-input-sticky-wrapper'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-input-wrapper ".concat(backgroundColorClass)
      }, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.onSubmit
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'input-group'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'search-bar-container'
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "search-bar input-group-field",
        type: "text",
        name: "search",
        id: "search",
        placeholder: this.props.placeholder,
        onChange: this.onChange,
        ref: this.inputRef,
        autoComplete: 'off',
        value: this.props.search,
        onClick: this.handleClickInside
      }), this.props.search.length > 0 && this.props.hasSearched && /*#__PURE__*/_react.default.createElement("div", {
        className: 'input-group-button'
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: 'reset',
        className: 'button reset-search',
        value: '',
        onClick: this.onReset
      })), (this.props.search.length <= 0 || !this.props.hasSearched) && /*#__PURE__*/_react.default.createElement("div", {
        className: 'input-group-button'
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: 'submit',
        className: 'button submit-search',
        value: ''
      })),
      /*#__PURE__*/

      /* filter button moves behind suggestions on mobile  */
      _react.default.createElement("div", {
        className: "filter-wrapper-mobile"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: '#',
        onClick: this.openModal,
        className: "button button--farm-search-filter filter-wrapper"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "filter-title"
      }, t('Filter'), count > 0 ? ' (' + count + ')' : ''))), this.state.showSuggestions && /*#__PURE__*/_react.default.createElement(_inputSuggest.default, {
        t: this.props.t,
        suggestions: this.props.suggestions,
        search: this.props.search,
        onSearch: this.resetSuggestions,
        hasSearched: this.props.hasSearched,
        showSuggestions: this.state.showSuggestions,
        innerRef: this.suggestionsRef
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-wrapper"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: '#',
        onClick: this.openModal,
        className: "button button--farm-search-filter filter-wrapper"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "filter-title"
      }, t('Filter'), count > 0 ? ' (' + count + ')' : '')))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "right-half"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_hofsearchMap.default, {
        locations: this.props.locations,
        outlets: this.props.outletLocations,
        outletsAll: this.props.outletsAll,
        history: this.props.history,
        theme: this.props.theme,
        showMap: this.props.showMap
      }), /*#__PURE__*/_react.default.createElement(_locationShareButton.default, {
        onSearch: this.props.scrollToListStart,
        startSearch: this.startSearchByLocation,
        showError: this.shareLocationError,
        t: this.props.t
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "left-half"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_hofsearchFilter.default, {
        setFilters: this.props.setFilters,
        onCloseFilterMenu: this.props.scrollToListStart,
        modalOpen: this.state.modalOpen,
        closeModal: this.closeModal,
        openModal: this.openModal,
        activeFilters: this.props.activeFilters,
        offersAvailability: this.props.offersAvailability,
        numbersOfResults: this.props.numberOfResults
      })))))));
    }
  }, {
    key: "openModal",
    value: function openModal(e) {
      e.preventDefault();
      this.setState(function (prev) {
        prev.modalOpen = true;
        return prev;
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState(function (prev) {
        prev.modalOpen = false;
        return prev;
      });
    }
  }]);

  return SearchField;
}(_react.default.Component);

SearchField.propTypes = {
  dispatch: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  t: _propTypes.default.func,
  getFilterCount: _propTypes.default.func,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onSearch: _propTypes.default.func,
  onPlaceSearch: _propTypes.default.func,
  viewportOffsetVisible: _propTypes.default.bool,
  search: _propTypes.default.string,
  handleInputChange: _propTypes.default.func.isRequired,
  numberOfResults: _propTypes.default.number,
  locations: _propTypes.default.array,
  outletLocations: _propTypes.default.array,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      hash: _propTypes.default.string
    })
  }),
  setFilters: _propTypes.default.func,
  scrollToListStart: _propTypes.default.func,
  checkLocationShareError: _propTypes.default.func,
  activeFilters: _propTypes.default.any,
  theme: _propTypes.default.string,
  outletsAll: _propTypes.default.array,
  closeModal: _propTypes.default.func,
  openModal: _propTypes.default.func,
  modalopen: _propTypes.default.bool,
  viewportOffsetStartRef: _propTypes.default.any,
  showMap: _propTypes.default.bool,
  hasSearched: _propTypes.default.bool,
  suggestions: _propTypes.default.shape({
    farms: _propTypes.default.array,
    products: _propTypes.default.array,
    locations: _propTypes.default.array
  }),
  offersAvailability: _propTypes.default.array
};
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 * @returns {{languages: Array|*|string[]}}
 */

var mapStateToProps = function mapStateToProps(state) {
  var stateObject = (0, _lodash.default)({}, state.farm, {
    filters: state.searchFilter
  }, {
    iframe: state.iframe
  }, {
    shared: state.shared
  });
  delete stateObject.search;
  return stateObject;
}; //TODO: Use props from search component instead of connecting to redux


var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(SearchField));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/search-field/index.js
// module id = 669
// module chunks = 0